var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled from "styled-components";
const StyledInputWrapper = styled.div `
  position: relative;
  flex: 1 1 0;
  min-width: 180px;
`;
const StyledInput = styled.input `
  position: absolute;
  height: 0;
  width: 0;
  opacity: 0;
  margin: 0;
`;
const StyledLabel = styled.label `
  display: flex;
  flex-direction: column;
  padding: 15px;
  background: ${props => (props.checked ? "rgba(96, 11, 111, 0.05)" : "white")};
  border-radius: 7px;
  outline: 1px ${props => (props.checked ? "#600B6F" : "#D6DAE0")} solid;
  outline-offset: -1px;
  gap: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
`;
const Badge = styled.div `
  padding: 4px 9px;
  background: rgba(96, 11, 111, 0.1);
  border-radius: 21px;
  display: inline-flex;
  align-self: flex-start;
`;
const BadgeText = styled.span `
  color: #600b6f;
  font-size: 12px;
  font-family: Inter, sans-serif;
  font-weight: 400;
  word-wrap: break-word;
`;
const AmountContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: 2px;
`;
const Amount = styled.span `
  color: #600b6f;
  font-size: 24px;
  font-family: "Plus Jakarta Sans", sans-serif;
  font-weight: 700;
  word-wrap: break-word;
`;
const Description = styled.span `
  color: #59256b;
  font-size: 12px;
  font-family: Inter, sans-serif;
  font-weight: 400;
  word-wrap: break-word;
`;
const PaymentOption = (_a) => {
    var { title, subtitle, price, id, checked = false, className } = _a, restProps = __rest(_a, ["title", "subtitle", "price", "id", "checked", "className"]);
    return (React.createElement(StyledInputWrapper, { className: className },
        React.createElement(StyledInput, Object.assign({ type: "radio", id: id, checked: checked }, restProps)),
        React.createElement(StyledLabel, { htmlFor: id, checked: checked },
            title && (React.createElement(Badge, null,
                React.createElement(BadgeText, null, title))),
            React.createElement(AmountContainer, null,
                React.createElement(Amount, null, price),
                subtitle && React.createElement(Description, null, subtitle)))));
};
export default PaymentOption;
